//Auth
export const AUTH_USER_INFO_KEY = 'auth_user_info_key';
export const AUTH_TENANT_INFO_KEY = 'auth_tenant_info_key';
export const CHECK_DOMAIN_KEY = 'CHECK_DOMAIN';

//Booking
export const GET_BOOKING_COVID_TABLE = 'get_booking_covid_table';
export const GET_EMPTY_SEATS = 'GET_EMPTY_SEATS';

































